<div *ngIf="formObject">
  <ng-container *ngIf="!invalidInput else invalidField">
    <mat-form-field appearance="standard" class="w-100" >
      <mat-label *ngIf="!placeholder" [ngStyle]="isFirst ? {'visibility': 'visible'} : {'visibility' : 'hidden'}">
        {{label}}
        <sup *ngIf="isInfo">
          <mat-icon class="fas fa-info" style="font-size: 0.5rem"></mat-icon>
        </sup>
      </mat-label>
      <mat-label *ngIf="placeholder" [ngStyle]="isFirst ? {'visibility': 'visible'} : {'visibility' : 'hidden'}">
        {{placeholder}}
      </mat-label>
      <mat-select [(ngModel)]="ngModelObject"
                  [disabled]="isDisabled"
                  [required]="required"
                  [name]="elementName"
                  (ngModelChange)="emitValue($event)">
        <mat-option *ngFor="let form of options" [value]="form.value">{{form.displayValue | translate}}</mat-option>
      </mat-select>
    </mat-form-field>
  </ng-container>
</div>

<ng-template #invalidField>
  <mat-form-field appearance="standard" class="w-100 mat-form-field-invalid ng-invalid">
    <mat-label [ngStyle]="isFirst ? {'visibility': 'visible'} : {'visibility' : 'hidden'}">
      {{label}}
      <sup *ngIf="isInfo">
        <mat-icon class="fas fa-info" style="font-size: 0.5rem"></mat-icon>
      </sup>
    </mat-label>
    <mat-select [(ngModel)]="ngModelObject"
                [disabled]="isDisabled"
                [required]="required"
                [name]="elementName"
                (ngModelChange)="emitValue($event)">
      <mat-option *ngFor="let form of options" [value]="form.value">{{form.displayValue | translate}}</mat-option>
    </mat-select>
    <mat-hint align="start" class="mt-1">
      {{errorMessage}}
    </mat-hint>
  </mat-form-field>
</ng-template>
